export const getDefaultValue = (defaultValue, key) => {
  return defaultValue ? (defaultValue[key] ? defaultValue[key] : "") : "";
};
